if (!customElements.get('size-card-picker')) {
  customElements.define(
    'size-card-picker',
    class SizeCardPicker extends HTMLElement {
      connectedCallback() {
        this._variantSelects = this.querySelector('variant-selects');
        this._cards = Array.from(this.querySelectorAll('.size-card'));
        this._panels = Array.from(this.querySelectorAll('.size-card-specs__panel'));
        this._pricesData = null;
        this._cards.forEach((card) => card.addEventListener('click', () => this._select(card)));
      }

      _select(card) {
        if (card.classList.contains('size-card--unavailable')) return;
        const variantId = card.dataset.variantId;

        // Update card visual states
        this._cards.forEach((c) => {
          c.classList.toggle('size-card--active', c === card);
          c.setAttribute('aria-pressed', String(c === card));
        });

        // Update specs panels
        this._panels.forEach((panel) => {
          panel.classList.toggle('size-card-specs__panel--active', panel.dataset.variantId === variantId);
        });

        // Directly update price display (instant, no AJAX wait)
        this._updatePrice(variantId);

        // Directly update the product form variant input (so Add to Cart works immediately)
        this._updateFormVariant(variantId);

        // Also fire the Shopify variant change event for media gallery / dynamic checkout
        this._syncVariantSelects(card);
      }

      _updatePrice(variantId) {
        if (!this._pricesData) {
          const el = this.querySelector('[data-variant-prices]');
          try {
            this._pricesData = el ? JSON.parse(el.textContent) : null;
          } catch (_) {
            this._pricesData = null;
          }
        }
        const data = this._pricesData?.[variantId];
        if (!data) return;

        const productInfo = this.closest('product-info');
        if (!productInfo) return;

        const priceEl = document.getElementById(`price-${productInfo.dataset.section}`);
        if (!priceEl) return;

        const onSale = data.rawCompare > 0 && data.rawCompare > data.rawPrice;

        // Update all price-item text nodes
        priceEl.querySelectorAll('.price-item--regular').forEach((el) => {
          el.textContent = onSale ? data.comparePrice : data.price;
        });
        priceEl.querySelectorAll('.price-item--sale').forEach((el) => {
          el.textContent = data.price;
        });

        priceEl.classList.toggle('price--sold-out', !data.available);
        priceEl.classList.toggle('price--on-sale', onSale);
      }

      _updateFormVariant(variantId) {
        const productInfo = this.closest('product-info');
        if (!productInfo) return;
        const sectionId = productInfo.dataset.section;
        productInfo
          .querySelectorAll(
            `#product-form-${sectionId}, #product-form-installment-${sectionId}`
          )
          .forEach((form) => {
            const input = form.querySelector('input[name="id"]');
            if (input) {
              input.value = variantId;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
      }

      _syncVariantSelects(card) {
        if (!this._variantSelects) return;
        const fieldsets = Array.from(this._variantSelects.querySelectorAll('fieldset'));
        let lastChanged = null;
        fieldsets.forEach((fieldset, i) => {
          const optValue = card.dataset[`option${i + 1}`];
          if (optValue === undefined) return;
          const radio = fieldset.querySelector(`input[value="${CSS.escape(optValue)}"]`);
          if (radio && !radio.checked) {
            radio.checked = true;
            lastChanged = radio;
          }
        });
        if (lastChanged) {
          lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  );
}
